import { call, takeLatest } from 'redux-saga/effects';
import FakePaymentApi, { CreateFakePaymentCredentialParams } from '@apis/FakePaymentApi';

import { fakePaymentCreate } from './action';
import { SagaPayload } from '@utils/typescript';
import { history } from '@utils/history';
import { routeThankYouPage } from '@components/ThankYouPage';

function* handleFakePaymentCreate({ payload }: SagaPayload<CreateFakePaymentCredentialParams & { isInsurancePolicy?: boolean }>) {
  try {
    const apiCall = payload.isInsurancePolicy ? FakePaymentApi.payInsurancePolicy : FakePaymentApi.pay;
    yield call(apiCall, payload);
    history.navigate(routeThankYouPage());
  } catch { }
}

export default function* () {
  yield takeLatest(fakePaymentCreate, handleFakePaymentCreate);
}
